import React, { Component, Fragment } from 'react';
// utils
import { Translations, checkReportingToCFF, convertStringToArray } from '../../../../utils';
// children
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';

class DeepAccountList extends Component {
  render() {
    const { account } = this.props
    return [
      <dt>{`Account ${this.props.keyId + 1}`}</dt>,
      <dd>
        <b>
          {account !== undefined && account.accountType !== undefined ? account.accountType.name : ''},
          {account !== undefined && account.country !== undefined ? this.props.accountCountryList !== undefined ? this.props.getCountryTaxonomy(account).country.name : account.country.name : ''},
          {account !== undefined && account.currency !== undefined ? account.currency.name : ''}</b>
        <br />
        <b>{account !== undefined && account.accountHolder !== undefined ? account.accountHolder.name : ''}</b>
        <div>
          {
            account !== undefined && account.eChannelReporting !== undefined && account.eChannelReporting.map(item => {
              if (item.eChannelId === this.props.id && item.productEnablements.length > 0) {
                return item.productEnablements.map(innerItem => {
                  return (<b>{innerItem.description},</b>)
                })
              }
            })
          }
          {
            account !== undefined && account.eChannelReporting !== undefined && account.eChannelReporting.map(item => {
              if (item.eChannelId === this.props.id) {
                return <b>{item.otherProductEnablements}</b>
              }
            })
          }
        </div>
      </dd>
    ]
  }
}

// class InnerAccountList extends Component {
//   render(){
//     const { account  } = this.props;
//     return (
//       <div>
//       {
//         account.map((item,key) => <DeepAccountList account={item} id={this.props.id} keyId={key}/>)
//       }
//       </div>
//     )
//   }
// }

class AccountListJSX extends Component {
  render() {
    var newArray = [];
    for (var i = 0; i < this.props.newAccounts.length; i++) {
      var filterArray = this.props.newAccounts[i].eChannelReporting.filter((inner, key) => {
        if (inner.eChannelId === this.props.id) {
          return 1
        }
      })
      if (filterArray.length > 0) {
        newArray.push(this.props.newAccounts[i])
      }
    }
    return (
      <div>
        {
          newArray.map((account, key) => <DeepAccountList account={account} innerId={key} id={this.props.id} keyId={key} accountCountryList={this.props.accountCountryList}
            getCountryTaxonomy={(item) => this.props.getCountryTaxonomy(item)} />)
        }
      </div>
    )
  }
}

class EchannelContactJSX extends Component {

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  render() {
    return [
      <dt>{`${this.translateWord(this.props.pageJson.dynamic_accordion_list_eChannels.fieldLabels)[36]} ${this.props.keyID + 1}`}</dt>,
      <dd>
        <b>{this.props.item.eChannelContact.firstName}{' '}{this.props.item.eChannelContact.lastName}, {this.props.item.eChannelContact.jobTitle}</b>
        <br />
        <b>{this.props.item.eChannelContact.emailAddress}</b>
        <div style={{ marginLeft: '155px' }}>
          <b>{this.props.item.eChannelContact.telephoneNumber !== undefined ? `Tel: ${this.props.item.eChannelContact.telephoneNumber}` : ''}</b>
          <b>{this.props.item.eChannelContact.faxNumber !== undefined ? `Fax: ${this.props.item.eChannelContact.faxNumber}` : ''}</b>
        </div>
      </dd>,
      <dt>{this.translateWord(this.props.pageJson.dynamic_accordion_list_eChannels.fieldLabels)[9]}</dt>,
      <dd>
        <b>
          {
            this.props.item.eChannelAddress !== null && this.props.item.eChannelAddress.addressLine1 !== undefined && this.props.item.eChannelAddress.addressLine1 !== ''
              ? `${this.props.item.eChannelAddress.addressLine1},`
              : ''
          }
          {
            this.props.item.eChannelAddress !== null && this.props.item.eChannelAddress.addressLine2 !== undefined && this.props.item.eChannelAddress.addressLine2 !== ''
              ? `${this.props.item.eChannelAddress.addressLine2},`
              : ''
          }
          {
            this.props.item.eChannelAddress !== null && this.props.item.eChannelAddress.addressLine3 !== undefined && this.props.item.eChannelAddress.addressLine3 !== ''
              ? `${this.props.item.eChannelAddress.addressLine3},`
              : ''
          }
          {
            this.props.item.eChannelAddress !== null && this.props.item.eChannelAddress.state !== undefined && this.props.item.eChannelAddress.state !== ''
              ? this.props.item.eChannelAddress.state
              : ''
          }</b>
      </dd>,
      <dt>{this.translateWord(this.props.pageJson.dynamic_accordion_list_eChannels.fieldLabels)[14]}</dt>,
      <dd>{this.props.item.attentionOf}</dd>
    ]
  }
}

function getEchannelAccountLine(account) {
  let accountString = '';
  if (account.hasOwnProperty('accountNumber')) {
    accountString += `${account.accountNumber},`;
  }
  if (account.hasOwnProperty('country')) {
    if (account.country.name) {
      accountString += `${account.country.name},`;
    }
  }
  if (account.hasOwnProperty('currency')) {
    if (account.currency.name) {
      accountString += `${account.currency.name}`;
    }
  }

  accountString = accountString.trim();
  if (accountString[accountString.length - 1] === ",") {
    accountString = accountString.substring(0, accountString.length - 1);
  }
  return accountString;
}

function getEchannelAccountHolderLine(account) {
  let bankDetailString = '';
  if (account.hasOwnProperty('bankName')) {
    if (account.bankName.trim() !== "") {
      bankDetailString += `${account.bankName},`;
    }
  }
  if (account.hasOwnProperty('hsbcAccount')) {
    if (account.hsbcAccount.trim() !== "") {
      bankDetailString += `${account.hsbcAccount.toUpperCase()},`;
    }
  }
  if (account.hasOwnProperty("accountHolder")) {
    if (account.accountHolder.name) {
      bankDetailString += `${account.accountHolder.name},`;
    }
  }
  if (account.hasOwnProperty("tradingName")) {
    bankDetailString += `${account.tradingName}`;
  }
  bankDetailString = bankDetailString.trim();
  if (bankDetailString[bankDetailString.length - 1] === ",") {
    bankDetailString = bankDetailString.substring(0, bankDetailString.length - 1);
  }
  return bankDetailString;
}

class EChannels extends Component {

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  getCountryTaxanomy = (val) => {
    let countryList = this.props.countryList;
    if (val !== undefined && countryList !== undefined) {
      let countryItem = countryList.find(x => x.id === val);
      if (countryItem !== undefined) {
        let countryName = countryItem.name;
        return countryName;
      }
    }
  }

  getProductRelatedTaxonomy(product) {
    if (product !== undefined) {
      this.props.accountCountryList.filter(countItem => {
        if ('country' in product) {
          if (countItem.id === product.country.value) {
            product.country.name = countItem.name
            if (product.accountType !== undefined) {
              countItem.associations.filter(accountType => {
                if (accountType.id === product.accountType.value) {
                  product.accountType.name = accountType.name
                }
              })
            }
          }
        }
      });
      return product;
    }
  }

  render() {
    const { echannels, newAccounts, pageJson } = this.props;
    /*=================================E-Channels start========================================================================*/
    return (
      <div className="gdoc-preview-request-content">
        <span>
          {Translations(pageJson.dynamic_accordion_list_eChannels.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
        </span>
        <NavListAccordionWrapper>
          {echannels.length > 0 ? echannels.map((item, key) => {

            const tabTitleHtml = (
              <div>
                <div className="Title">
                  {item.eChannelType !== undefined && item.eChannelType.name !== undefined ? item.eChannelType.name : ""},
                  {item.country !== undefined && item.country !== undefined ? this.getCountryTaxanomy(item.country.value) : ""}
                  <span className="echanelExiting">
                    ({item.newEchannel !== undefined && item.newEchannel === false ? (`Existing ID : ${item.eChannelId}`) : "New"})
                  </span>
                </div>
                <div className="SubTitle">
                  {item.profileOwner.name !== undefined ? item.profileOwner.name + " " : ""}
                  {item.newEchannel !== undefined && (<span className="echanelExitingsub">item.newEchannel</span>) === false ? item.eChannelId : ""}
                </div>
              </div>
            );
            /*=================================TabPanelContentBasicDetails start================*/
            const TabPanelContentBasicDetails = (
              <div className="basic-details-container">
                <div className="basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[15]}</div>
                <div className="basic-detail-content">
                  <dl className="dl-horizontal">
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[13]}</dt>
                    <dd><b>{item.newEchannel !== undefined ? item.newEchannel === true ? 'New' : 'Existing' : ""}</b></dd>
                    {
                      'eChannelId' in item && item.eChannelId !== undefined && item.newEchannel !== true
                        ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[40]}</dt>)
                        : ''
                    }
                    {
                      'eChannelId' in item && item.eChannelId !== undefined && item.newEchannel !== true
                        ? (<dd><b>{item.eChannelId}</b></dd>)
                        : ''
                    }
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[31]}</dt>
                    <dd><b>{item.profileOwner !== undefined && item.profileOwner.name !== undefined ? item.profileOwner.name : ""}</b></dd>
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[37]}</dt>
                    <dd><b>{item.country !== undefined && item.country.name !== undefined ? this.getCountryTaxanomy(item.country.value) : ""}</b></dd>
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[26]}</dt>
                    <dd><b>{item.eChannelType !== undefined && item.eChannelType.name !== undefined ? item.eChannelType.name : ""}</b></dd>
                    {
                      item.newEchannel === true ?
                        'eChannelId' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                          ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[40]}</dt>)
                          : ''
                        : ''
                    }
                    {item.newEchannel === true ?
                      'eChannelId' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dd><b>{item.eChannelId !== undefined ? item.eChannelId : ""}</b></dd>)
                        : ''
                      : ''
                    }
                    {
                      item.newEchannel === true ?
                        'swiftBIC' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'swiftNet'
                          ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[41]}</dt>)
                          : ''
                        : ''
                    }
                    {item.newEchannel === true ?
                      'swiftBIC' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'swiftNet'
                        ? (<dd><b>{item.swiftBIC !== undefined ? item.swiftBIC : ""}</b></dd>)
                        : ''
                      : ''
                    }
                    {
                      'surAvailable' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[0]}</dt>)
                        : ''
                    }
                    {
                      'surAvailable' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dd><b>{item.surAvailable !== undefined ? item.surAvailable === true ? 'Yes' : 'NO' : ""}</b></dd>)
                        : ''
                    }
                    {
                      'sur' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[39]}</dt>)
                        : ''
                    }
                    {
                      'sur' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dd><b>{item.sur !== undefined ? item.sur === true ? 'Yes' : 'NO' : ""}</b></dd>)
                        : ''
                    }
                    {
                      item.newEchannel === true
                        ? ('erpLink' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined) && ((item.eChannelType.name === 'HSBC Connect to SAP') || (item && item.eChannelType.name === 'SWIFT') || (item && item.eChannelType.name === 'HSBC Connect'))
                          ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[38]}</dt>)
                          : ''
                        : ''
                    }
                    {
                      item.newEchannel === true
                        ? ('erpLink' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined) && ((item.eChannelType.name === 'HSBC Connect to SAP') || (item && item.eChannelType.name === 'SWIFT') || (item && item.eChannelType.name === 'HSBC Connect'))
                          ? (<dd><b>{item.erpLink !== undefined ? item.erpLink === true ? 'Yes' : 'NO' : ""}</b></dd>)
                          : ''
                        : ''
                    }
                    {
                      'singleSignOn' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[45]}</dt>)
                        : ''
                    }
                    {
                      'singleSignOn' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dd><b>{item.singleSignOn !== undefined ? item.singleSignOn === true ? 'Yes' : 'NO' : ""}</b></dd>)
                        : ''
                    }
                    {
                      'ipWhitelisting' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[46]}</dt>)
                        : ''
                    }
                    {
                      'ipWhitelisting' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBCnet'
                        ? (<dd><b>{item.ipWhitelisting !== undefined ? item.ipWhitelisting === true ? 'Yes' : 'NO' : ""}</b></dd>)
                        : ''
                    }
                    {
                      item.newEchannel === false ?
                        'apiProfileId' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBC Corporate API'
                          ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[49]}</dt>)
                          : ''
                        : ''
                    }
                    {
                      item.newEchannel === false && 'apiProfileId' in item && item.eChannelType !== undefined && item.eChannelType.name !== undefined && item.eChannelType.name === 'HSBC Corporate API'
                        ? (<dd><b>{item.apiProfileId !== undefined ? item.apiProfileId : ''}</b></dd>)
                        : ''
                    }
                  </dl>
                </div>
              </div>
            );
            /*=================================TabPanelContentBasicDetails end==============================*/

            /*=================================Tab Panel Content Echannel Contacts Start=====================*/
            const TabPanelContentEchannelContact = (
              <div className="echannel-contact-container">
                <div className="echannel-contact-heading">
                  {this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[20]}
                </div>
                <div className="echannel-contact-content">
                  <dl className="dl-horizontal">
                    <dt>
                      {this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[11]}
                    </dt>
                    <dd>
                      <b>{item.hostToHostContact === true ? 'Yes' : 'No'}</b>
                    </dd>
                    {
                      item.echannelContactInfo.map((item, key) => <EchannelContactJSX
                        item={item}
                        eChannels={echannels}
                        keyID={key}
                        pageJson={this.props.pageJson}
                        lang={this.props.lang}
                      />)
                    }
                  </dl>
                </div>
              </div>
            )
            /*=================================Tab Panel Content Echannel Contacts end=====================*/

            /*=================================TabPanelContentAccountAddressAndContacts start================*/
            const TabPanelContentAccessControlAndLimits = (
              <div className="account-address-container">
                <div className="account-address-heading">{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[1]}</div>
                <div className="account-address-content">
                  <dl className="dl-horizontal">
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[27]}</dt>
                    <dd><b>{item.accessControl !== undefined && item.accessControl.adminControl !== undefined && item.accessControl.adminControl.name !== undefined ? item.accessControl.adminControl.name : ""}</b></dd>
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[29]}</dt>
                    <dd><b>{item.accessControl !== undefined && item.accessControl.securityMethod !== undefined && item.accessControl.securityMethod.name !== undefined ? item.accessControl.securityMethod.name : ""}</b></dd>
                  </dl>
                  <div className="dl-horizontal">
                    {
                      item.eChannelAdmins !== undefined ? item.eChannelAdmins.map((it, key) => {
                        return (
                          <dl className="gdoc-echannel-repeat" key={key}>
                            <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[28]} {key + 1}</dt>
                            <dd><b>
                              {it.admin !== undefined && it.admin.firstName !== undefined ? it.admin.firstName : ""},
                              {it.admin !== undefined && it.admin.lastName !== undefined ? it.admin.lastName : ""},
                              {it.admin !== undefined && it.admin.jobTitle !== undefined ? it.admin.jobTitle : ""}
                            </b></dd>
                            <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[44]}</dt>
                            <dd><b>{it.dateOfBirth !== undefined ? it.dateOfBirth : ""}</b></dd>
                            <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[23]}</dt>
                            <dd><b>{it.emailAddress !== undefined ? it.emailAddress : ""}</b></dd>
                            <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[8]}</dt>
                            <dd><b>{it.officeTelephoneCountryCode !== undefined && it.officeTelephoneCountryCode.name !== undefined ? it.officeTelephoneCountryCode.name : ""}
                              {it.officeTelephoneNumberCountryCode && it.officeTelephoneNumberCountryCode.name} {it.officeTelephoneNumberAreaCode && it.officeTelephoneNumberAreaCode.name} {it.officeTelephoneNumber && it.officeTelephoneNumber}
                            </b></dd>
                            <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[5]}</dt>
                            <dd><b>{it.mobileCountryCode !== undefined && it.mobileCountryCode.name !== undefined ? it.mobileCountryCode.name : ""}
                              {it.mobileNumberCountryCode && it.mobileNumberCountryCode.name} {it.mobileNumberAreaCode && it.mobileNumberAreaCode.name} {it.mobileNumber && it.mobileNumber}
                            </b>
                            </dd>
                            {
                              'autoEntitlementServices' in it
                                ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[32]}</dt>)
                                : ''
                            }
                            {
                              'autoEntitlementServices' in it
                                ? (<dd><b>{it.autoEntitlementServices !== undefined ? it.autoEntitlementServices === true ? "Yes" : "NO" : ""}</b></dd>)
                                : ''
                            }
                            {
                              'smartCardReader' in it
                                ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[21]}</dt>)
                                : ''
                            }
                            {
                              'smartCardReader' in it
                                ? (<dd><b>{it.smartCardReader !== undefined && it.smartCardReader.name !== undefined ? it.smartCardReader.name : ""}</b></dd>)
                                : ''
                            }
                            {
                              item.accessControl !== undefined && item.accessControl.securityMethod !== undefined && item.accessControl.securityMethod.value !== undefined && item.accessControl.securityMethod.value !== 'mobileDevice' && 'securityDevices' in it
                                ? [
                                  <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[12]}</dt>,
                                  <dd><b>{it.securityDevices !== undefined ? it.securityDevices.value : ""}</b></dd>
                                ]
                                : ''
                            }
                            {
                              item.accessControl !== undefined && item.accessControl.securityMethod.value !== 'mobileDevice' ? 'address' in it
                                ?
                                <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[30]}</dt>
                                : '' : ''
                            }
                            {
                              item.accessControl !== undefined && item.accessControl.securityMethod.value !== 'mobileDevice' ? 'address' in it
                                ? (<dd>
                                  <b>
                                    <span>
                                      {it.address !== undefined && it.address.addressLine1 !== undefined ? it.address.addressLine1 : ""}
                                      {it.address !== undefined && it.address.addressLine2 !== undefined ? `${it.address.addressLine2},` : ""}
                                      {it.address !== undefined && it.address.addressLine3 !== undefined ? `${it.address.addressLine3},` : ""}
                                    </span>
                                    <br />
                                    <span>
                                      {it.address !== undefined && it.address.city !== undefined ? `${it.address.city},` : ""}
                                      {it.address !== undefined && it.address.state !== undefined ? `${it.address.state},` : ""}
                                      {it.address !== undefined && it.address.postCode !== undefined ? `${it.address.postCode},` : ""}
                                      {it.address !== undefined && it.address.country !== undefined ? `${this.getCountryTaxanomy(it.address.country.value)}` : ""}
                                    </span>
                                  </b>
                                </dd>)
                                : '' : ''
                            }
                          </dl>

                        )
                      }) : "<div></div>"}
                  </div>
                  <dl className="dl-horizontal">
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[33]}</dt>
                    <dd><b>{item.authorisationLimitsCurrency !== undefined ? item.authorisationLimitsCurrency.name : ''}</b></dd>
                  </dl>
                </div>
              </div>
            );
            /*=================================TabPanelContentAccountAddressAndContacts end=========================*/
            /*=================================TabPanelContentProductEnablement start================*/
            const TabPanelContentProductEnablement = (
              <div className="account-address-container">
                <div className="account-address-heading">
                  {this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[17]}
                </div>
                <div className="account-address-content">
                  <dl className="dl-horizontal">
                    {
                      'profileLevelProducts' in item && item.profileLevelProducts !== undefined
                        ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[47]}</dt>)
                        : ''
                    }
                    {
                      'profileLevelProducts' in item && item.profileLevelProducts !== undefined
                        ? (
                          <dd>
                            <b>
                              {item.profileLevelProducts.map(p => (<li key={p.id}>{p.name} ({p.description})</li>))}
                            </b>
                          </dd>
                        )
                        : ''
                    }
                    {
                      'otherProfileLevelProducts' in item && item.otherProfileLevelProducts !== undefined
                        ? (<dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[48]}</dt>)
                        : ''
                    }
                    {
                      'otherProfileLevelProducts' in item && item.otherProfileLevelProducts !== undefined
                        ? (<dd><b>{item.otherProfileLevelProducts}</b></dd>)
                        : ''
                    }
                    {checkReportingToCFF(this.props.cffProduct, item.id) &&
                      <Fragment>
                        <dt>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[42]}</dt>
                        <dd><b>{this.translateWord(pageJson.dynamic_accordion_list_eChannels.fieldLabels)[43]}</b>
                        </dd>
                      </Fragment>
                    }
                    <AccountListJSX
                      item={item.caseId}
                      newAccounts={newAccounts}
                      keyID={key}
                      pageJson={this.props.pageJson}
                      id={item.id}
                      accountCountryList={this.props.accountCountryList}
                      getCountryTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                    />
                    {
                      item.otherAccounts !== undefined && item.otherAccounts.map((account, item) => {
                        return (
                          <div>
                            <dt>{`Other Account ${item + 1} `}</dt>
                            <dd>
                              <b>
                                {account !== undefined && account.accountNumber !== undefined ? account.accountNumber : ''},
                                {account !== undefined && account.country !== undefined ? this.props.accountCountryList !== undefined
                                  ? this.getProductRelatedTaxonomy(account).country.name : account.country.name : ''},
                                {account !== undefined && account.currency !== undefined ? account.currency.name : ''},
                                {account !== undefined && account.branchCode !== undefined ? account.branchCode : ''}
                              </b>
                              <br />
                              <b>
                                {account !== undefined && account.bankName !== undefined ? `${account.bankName},` : ''}</b>
                              <b>
                                {account !== undefined && account.accountHolder !== undefined && account.accountHolder !== 'true' ? `${account.accountHolder.name}` : ''}
                              </b>
                              <b>
                                {account !== undefined && account.tradingName !== undefined && account.accountHolder === undefined ? ` ,${account.tradingName}` : ''}
                              </b>
                              <div style={{ marginLeft: '155px' }}>
                                {
                                  account !== undefined && account.productEnablements.length > 0 && account.productEnablements.map(innerItem => {
                                    return (<b>{innerItem.description},</b>)
                                  })
                                }
                                {
                                  account !== undefined && account.otherProductEnablements !== undefined
                                    ? (<b>{account.otherProductEnablements}</b>)
                                    : ''
                                }
                              </div>
                            </dd>
                          </div>
                        )
                      })
                    }
                    {
                      item.glsOtherAccounts !== undefined && item.glsOtherAccounts.map((account, index) => {
                        return (
                          <div>
                            <dt>{`Gls Other Account ${index + 1} `}</dt>
                            <dd>
                              <b>
                                {getEchannelAccountLine(account)}
                              </b>
                              <br />
                              <b>
                                {getEchannelAccountHolderLine(account)}
                              </b>
                              <div style={{ marginLeft: '155px' }}>
                                {
                                  account !== undefined && account.eChannelReporting[0].productEnablements && account.eChannelReporting[0].productEnablements.length > 0 && account.eChannelReporting[0].productEnablements.map((innerItem, idx) => {
                                    if (idx >= account.eChannelReporting[0].productEnablements.length - 1 && account.eChannelReporting[0].otherProductEnablements === undefined) {
                                      return (<b>{innerItem.description}</b>)
                                    } else {
                                      return (<b>{innerItem.description},</b>)
                                    }

                                  })
                                }
                                {
                                  account !== undefined && account.eChannelReporting[0].otherProductEnablements !== undefined
                                    ? (<b>{account.eChannelReporting[0].otherProductEnablements}</b>)
                                    : ''
                                }
                              </div>
                            </dd>
                          </div>
                        )
                      })
                    }
                    {
                      item.achOtherAccounts !== undefined && item.achOtherAccounts.map((account, index) => {
                        return (
                          <div>
                            <dt>{`ACH Credit Other Account ${index + 1} `}</dt>
                            <dd>
                              <b>
                                {getEchannelAccountLine(account)}
                              </b>
                              <br />
                              <b>
                                {getEchannelAccountHolderLine(account)}
                              </b>
                              <div style={{ marginLeft: '155px' }}>
                                {
                                  account !== undefined && account.eChannelReporting[0].productEnablements && account.eChannelReporting[0].productEnablements.length > 0 && account.eChannelReporting[0].productEnablements.map((innerItem, idx) => {
                                    if (idx >= account.eChannelReporting[0].productEnablements.length - 1 && account.eChannelReporting[0].otherProductEnablements === undefined) {
                                      return (<b>{innerItem.description}</b>)
                                    } else {
                                      return (<b>{innerItem.description},</b>)
                                    }

                                  })
                                }
                                {
                                  account !== undefined && account.eChannelReporting[0].otherProductEnablements !== undefined
                                    ? (<b>{account.eChannelReporting[0].otherProductEnablements}</b>)
                                    : ''
                                }
                              </div>
                            </dd>
                          </div>
                        )
                      })
                    }
                    <div>
                      <dt>Manual Account Filling</dt>
                      <dd>{item.manualAccountNumberFilling !== undefined && typeof item.manualAccountNumberFilling === 'boolean' ? (item.manualAccountNumberFilling ? 'Yes' : 'No') : ''}</dd>
                    </div>
                  </dl>
                </div>
              </div>
            );
            /*=================================TabPanelContentAccountAddressAndContacts end=========================*/
            return (
              <NavListAccordion navAccHeading={tabTitleHtml} key={key}>
                <div className="basic-details-section">
                  {TabPanelContentBasicDetails}
                  <span className="basic-details-section-bar"></span>
                  {
                    'hostToHostContact' in item
                      ? TabPanelContentEchannelContact
                      : ''
                  }
                  <span className="basic-details-section-bar"></span>
                  {
                    'accessControl' in item
                      ? TabPanelContentAccessControlAndLimits
                      : ''
                  }
                  <span className="basic-details-section-bar"></span>
                  {TabPanelContentProductEnablement}
                </div>
              </NavListAccordion>
            )
          }) : ""}
        </NavListAccordionWrapper>
      </div>
    )

  }

  /*=================================E-Channels end========================================================================*/
}

export default EChannels;


// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/EChannels.js